export const dlActionTypes = {
  FETCH_DL_PROFILES_START: 'FETCH_DL_PROFILES_START',
  FETCH_DL_PROFILES_SUCCESS: 'FETCH_DL_PROFILES_SUCCESS',
  FETCH_DL_PROFILES_FAILED: 'FETCH_DL_PROFILES_FAILED',
  SET_DL_PROFILES: 'SET_DL_PROFILES',
};
